import { Linkedin, Instagram } from 'lucide-react';
import maneLogo from '../assets/MANE_logo1.png';

export default function Footer() {
  return (
    <footer className="bg-michigan-blue text-white py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto text-center">
        <div className="flex items-center justify-center space-x-2 mb-4">
          <img src={maneLogo} alt="MANE Logo" className="w-8 h-8" />
          <span className="font-bold text-lg">Michigan Advocates for Nuclear Energy</span>
        </div>
        <p className="text-blue-200">University of Michigan Student Organization</p>
        
        {/* Social Media Links */}
        <div className="flex items-center justify-center space-x-6 mt-6 mb-4">
          <a 
            href="https://www.linkedin.com/in/michiganavdocatesfornuclearengineering/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-michigan-maize hover:text-yellow-300 transition transform hover:scale-110"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-8 h-8" />
          </a>
          <a 
            href="https://www.instagram.com/mane.michigan/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-michigan-maize hover:text-yellow-300 transition transform hover:scale-110"
            aria-label="Instagram"
          >
            <Instagram className="w-8 h-8" />
          </a>
        </div>
        
        <p className="text-blue-300 text-sm mt-4">© 2025 MANE. All rights reserved.</p>
      </div>
    </footer>
  );
}
